import React from 'react'

export default function Content({ children }) {
  return <div className="py-3 px-4">{children}</div>
}
